import RedeemQR from "./RedeemQR";

export default RedeemQR;